import { createFileRoute } from "@tanstack/react-router"
import { AccountsTab } from "./_accounts-tab"

export const Route = createFileRoute("/settings/accounts")({
  component: AccountsTab,
})
